import { StateCreator } from "zustand";
import {
HeatedSegment,
MAIN_PROPERTIES,
  MAIN_PROPERTIES_DEFAULT,
  MAIN_PROPERTY_HINTS,
  MAIN_PROPERTY_LABELS,
  MAIN_PROPERTY_PLACEHOLDERS,
  MainProperties,
  MainPropertyKey,
  MainPropertyValue,
  MIN_BAUJAHR,
  RoofOrientation,
  type MainPropertiesDeclare,
} from "./properties.ts";
import { PropertiesAutoFillState } from "./types.ts";
import { AppSlice } from "./app-slice.ts";
import { ApiSlice } from "./api-slice.ts";
import { add_session_token_handler } from "./state.ts";

let menu_timeout : number | undefined = undefined;

export interface PropertySlice extends MainProperties{
  get_property_config: (key: MainPropertyKey) => MainPropertiesDeclare | undefined;
  get_property_label: (key: MainPropertyKey) => string;
  get_property_hint: (key: MainPropertyKey) => string;
  get_property_placeholder: (key: MainPropertyKey) => string;
  get_property: (key: MainPropertyKey) => MainPropertyValue;
  get_property_as_string: (key: MainPropertyKey) => string;
  get_property_as_number: (key: MainPropertyKey) => number;
  set_property: (key: MainPropertyKey, value: MainPropertyValue) => void;
  init_property_if_undefined: (key: MainPropertyKey) => void;
  fill_development_data: () => void;
  gewerke:Record<string, Array<number>>;
  properties_changed: Array<MainPropertyKey>;
  propertyUpdate: number;
  properties_auto_fill_state : Partial<Record<MainPropertyKey, PropertiesAutoFillState | undefined>>,
}

export const createPropertySlice: StateCreator<AppSlice & ApiSlice & PropertySlice, [], [], PropertySlice> = (
  set,
  get,
) => ({
  ...MAIN_PROPERTIES_DEFAULT,
  
  properties_auto_fill_state : {},
  properties_changed: [],
  propertyUpdate: 0,
  privat:true,
  gewerke: {},

  fill_development_data: () => {
    get().api_check_zip("61267");
    get().set_property("postleitzahl", "61267");
    get().set_property("vollgeschosse", 3);
    get().set_property("wohneinheiten", 2);
    get().set_property("baujahr_base", MIN_BAUJAHR);
    get().set_property("baujahr", MIN_BAUJAHR);
    get().set_property("wohnflaeche", 120);

    set((_state) => ({ 
      postleitzahl: "61267",
      vollgeschosse: 3,
      wohneinheiten: 2,
      baujahr_base: MIN_BAUJAHR,
      baujahr: MIN_BAUJAHR,
      wohnflaeche: 120,
    }));

    console.log("FILL DEBUG DATA");
  },

  get_property_config: (key) => {
    return MAIN_PROPERTIES.find(property => property.key == key);
  },
  get_property_label: (key) => {
    return MAIN_PROPERTY_LABELS[key] ?? "";
  },
  get_property_hint: (key) => {
    return MAIN_PROPERTY_HINTS[key] ?? "";
  },
  get_property_placeholder: (key) => {
    return (MAIN_PROPERTY_PLACEHOLDERS[key] ?? "").toString();
  },
  get_property: (key) => {
    return get()[key] as unknown as MainPropertyValue;
  },
  get_property_as_number: (key) => {
    const x = parseInt(get()[key] as unknown as string);
    return Number.isNaN(x) ? 0 : x;
  },
  get_property_as_string : (key) => {
    let prop = get()[key] as unknown;
    if (prop !== null && prop !== undefined){
      return prop.toString();
    }
    return "";
  },
  set_property: (key, value) => {
    if (
      key == "heizung_isfp" ||
      key == "keller_isfp" ||
      key == "dach_isfp" ||
      key == "fenster_isfp" ||
      key == "fassade_isfp" ||
      key == "solarthermie_isfp" ||
      key == "photovoltaik_isfp" ||
      key == "lueftung_isfp"
    ){
      const isfp_value = value as boolean;
      set((_state) => ({
        heizung_isfp: isfp_value,
        keller_isfp: isfp_value,
        dach_isfp: isfp_value,
        fenster_isfp: isfp_value,
        fassade_isfp: isfp_value,
        solarthermie_isfp: isfp_value,
        photovoltaik_isfp: isfp_value,
        lueftung_isfp : isfp_value,
      }));
    }
    
    if(key == "postleitzahl"){
      add_session_token_handler(()=>{
        get().api_check_zip(value as string);
      });
    }

    if(key == "heizung"){
      set((_state) => ({ [key]: value } as any));
      const energy_costs_table = get().energy_costs_table;
      if (energy_costs_table){
        const energy_costs = energy_costs_table.heating_systems.find((heating_system)=>heating_system.code == value);
        if (energy_costs){
          get().set_energy_costs_current(energy_costs.energy_costs);
        }
      }
      add_session_token_handler(async () => {
        await get().api_basic_data();
        await get().api_recalculate();
      });
      return;
    }

    if(key == "heizung_future"){
        const energy_costs_table = get().energy_costs_table;
        if (energy_costs_table){
          const energy_costs = energy_costs_table.heating_systems.find((heating_system)=>heating_system.code == value);
          if (energy_costs){
            get().set_energy_costs_planned(energy_costs.energy_costs);
          }
        }
    }

    if(key == "baujahr_base" || key == "baujahr"){
      set((_state) => ({ properties_auto_fill_state: {...get().properties_auto_fill_state, "baujahr_base": undefined, "baujahr" : undefined} }));
    }

    set((_state) => ({ [key] : value, properties_auto_fill_state: {...get().properties_auto_fill_state, [key] : undefined} }));
  },

  init_property_if_undefined: (key) => {
    if (get()[key] == undefined){
      const prop = MAIN_PROPERTIES.find((p) => p.key == key);
      if (prop){
        set((_state) => ({ [key] : prop.default }));
      }
    }
  },
});
